/**
 * Get currency display to replace the zeros for K.
 * For example, 1000 will be 1K.
 * @param amount
 */
export default (amount = 0) => {
  if (amount >= 1000) {
    return `${Math.round(amount / 1000)}K`;
  }
  return amount;
};
